import { defineSlotRecipe } from "@chakra-ui/react-v3";

import { focusRing } from "theme/tokens/accessibility";

const slots = [
  "root",
  "image",
  "content",
  "label",
  "description",
  "endElement",
] as const;

const $tileBg = "--tile-bg";
const $tileStrokeColor = "--tile-stroke-color";
const $tileStrokeThickness = "--tile-stroke-thickness";
const $tileLabelColor = "--tile-label-color";

export const selectableTileRecipe = defineSlotRecipe({
  slots,

  base: {
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",

      textAlign: "left",
      gap: "3",
      py: "3",
      px: "4",
      width: "254px",
      bgColor: `var(${$tileBg})`,
      boxShadow: `inset 0 0 0 var(${$tileStrokeThickness}) var(${$tileStrokeColor})`,
      borderRadius: "lg",
      cursor: "pointer",

      _focusVisible: {
        ...focusRing,
      },

      _active: {
        transform: "translateY(1px)",
      },
    },

    image: {},

    content: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
    },

    label: {
      color: `var(${$tileLabelColor})`,
    },

    description: {
      color: "fg.emphasized",
    },

    endElement: {
      marginLeft: "auto",
      flexShrink: 0,
    },
  },

  variants: {
    variant: {
      default: {
        root: {
          [$tileBg]: "{colors.bg.container}",
          [$tileStrokeColor]: "{colors.neutral.muted}",
          [$tileStrokeThickness]: "1px",
          [$tileLabelColor]: "{colors.fg.emphasized}",

          _hover: {
            [$tileBg]: "{colors.highlight.subtle}",
            [$tileStrokeColor]: "{colors.highlight.solid}",
            [$tileLabelColor]: "{colors.fg.default}",
          },

          _selected: {
            [$tileBg]: "{colors.highlight.default}",
            [$tileStrokeColor]: "{colors.highlight.solid}",
            [$tileStrokeThickness]: "2px",
            [$tileLabelColor]: "{colors.fg.default}",
          },
        },
      },

      grayscale: {
        root: {
          [$tileBg]: "{colors.bg.container}",
          [$tileStrokeColor]: "{colors.border.divider}",
          [$tileStrokeThickness]: "2px",

          _selected: {
            [$tileStrokeColor]: "{colors.border.inverted}",
          },
        },
      },
    },

    compact: {
      true: {
        root: {
          alignItems: "stretch",
          justifyContent: "stretch",
          flexDirection: "column",
        },
      },
    },

    size: {
      lg: {
        root: {
          h: "15",
          px: "10",
          py: "4",
        },
      },
    },
  },

  defaultVariants: {
    variant: "default",
    compact: false,
  },
});
